const getters = {
  userInfo: state => state.userInfo

}
export default getters